import React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Divider, Box, Avatar, Stack, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const BeneficiariesDetails = ({ headerNames, beneficiaries, onClose }) => {

    if (!beneficiaries)
        return <Typography variant="h6">Select a beneficiary to view details</Typography>;

    const tableHeaders = [
        { label: 'Field', width: '30%' },
        { label: 'Value', width: '70%' },
    ];

    const tableData = [
        // { field: 'id', headerName: 'ID', value: beneficiaries?.id },
        { field: 'eb_company_name', value: beneficiaries?.eb_company_name },
        { field: 'eb_vat_no', value: beneficiaries?.eb_vat_no },
        { field: 'eb_address', value: beneficiaries?.eb_address },
        { field: 'eb_phone', value: beneficiaries?.eb_phone },
        { field: 'eb_email', value: beneficiaries?.eb_email },
        { field: 'eb_payment_terms', value: beneficiaries?.eb_payment_terms }
    ];

    return (
        <Paper elevation={3} sx={{ padding: 2, borderRadius: 2, backgroundColor: '#f4f6f8', height: '100%' }}>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                <Stack direction="row" spacing={2} alignItems="center">
                    {/* Optional Title */}
                </Stack>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Stack>
            <Divider sx={{ marginBottom: 2 }} />
            <TableContainer component={Box}>
                <Table>
                    <TableBody>
                        {tableData.map((row, index) => (
                            <TableRow key={index}>
                                {/* Display header name from headerNames */}
                                <TableCell sx={{ color: '#757575', backgroundColor: index % 2 ? '#fafafa' : '#ffffff' }}>
                                    {headerNames[row.field]}
                                </TableCell>
                                <TableCell sx={{ color: '#757575', backgroundColor: index % 2 ? '#fafafa' : '#ffffff' }}>
                                    {row.value}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default BeneficiariesDetails;